import ClearIndicatorSvg from '../images/ClearIndicator.svg?react';
import { ClearIndicatorProps } from 'react-select';
import { ClearIndicatorWrapper } from './styles';

export const ClearIndicator = (props: ClearIndicatorProps) => {
  return (
    <ClearIndicatorWrapper {...props.innerProps}>
      <ClearIndicatorSvg width={10} height={10} />
    </ClearIndicatorWrapper>
  );
};
